export const getWidgetDomain = () => {
  try {
    // Try to get the parent window's hostname
    return window.parent.location.hostname;
  } catch {
    // If cross-origin restrictions prevent access, use document.referrer
    try {
      const referrer = document.referrer;
      if (referrer) {
        return new URL(referrer).hostname;
      }
    } catch {
      // Fallback if both methods fail
      return window.location.hostname;
    }
  }
  return "unknown";
};
